import React from 'react';

const ChatbotWidget: React.FC = () => {
  return (
    <div
      style={{
        position: 'relative',
        minHeight: '280px',
        background: 'linear-gradient(135deg, #0F2744 0%, #1A6FA8 100%)',
        borderRadius: '8px',
        overflow: 'hidden',
        padding: '1.4rem',
        fontFamily: "'Montserrat', sans-serif",
        boxShadow: '0 20px 60px -20px rgba(26,111,168,.25)',
      }}
    >
      {/* Fake website background */}
      <div style={{ opacity: .25, display: 'flex', flexDirection: 'column', gap: '.4rem' }}>
        <div style={{ height: '10px', width: '40%', background: 'white', borderRadius: '2px' }} />
        <div style={{ height: '6px', width: '70%', background: 'white', borderRadius: '2px' }} />
        <div style={{ height: '6px', width: '60%', background: 'white', borderRadius: '2px' }} />
        <div style={{ height: '6px', width: '65%', background: 'white', borderRadius: '2px' }} />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '.4rem', marginTop: '.6rem' }}>
          {[0, 1, 2].map((i) => <div key={i} style={{ height: '40px', background: 'white', borderRadius: '3px' }} />)}
        </div>
      </div>

      {/* Glow */}
      <div style={{
        position: 'absolute', top: '-40px', right: '-40px', width: '160px', height: '160px',
        background: 'radial-gradient(circle, rgba(184,146,42,.4), transparent 70%)', pointerEvents: 'none',
      }} />

      {/* Chat widget */}
      <div
        style={{
          position: 'absolute',
          right: '1.2rem',
          bottom: '1.2rem',
          width: '220px',
          background: 'var(--white)',
          borderRadius: '10px',
          overflow: 'hidden',
          boxShadow: '0 15px 40px rgba(0,0,0,.25)',
        }}
      >
        {/* Header */}
        <div style={{ background: 'linear-gradient(135deg, var(--blue), #5E35B1)', padding: '.6rem .7rem', color: 'white' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '.4rem' }}>
            <div style={{ width: '24px', height: '24px', background: 'rgba(255,255,255,.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.7rem' }}>✦</div>
            <div>
              <div style={{ fontSize: '.6rem', fontWeight: 700 }}>Miid Assist</div>
              <div style={{ fontSize: '.45rem', opacity: .8, display: 'flex', alignItems: 'center', gap: '.2rem' }}>
                <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#4ADE80' }} /> En ligne
              </div>
            </div>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: '.6rem .65rem', background: '#F7FAFC', maxHeight: '170px', overflow: 'hidden' }}>
          {/* Bot message */}
          <div style={{ display: 'flex', gap: '.3rem', marginBottom: '.4rem' }}>
            <div style={{ width: '18px', height: '18px', background: 'var(--blue)', color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.55rem', flexShrink: 0 }}>✦</div>
            <div style={{ background: 'var(--white)', padding: '.35rem .5rem', borderRadius: '8px 8px 8px 2px', fontSize: '.52rem', color: 'var(--ink)', lineHeight: 1.4, border: '1px solid var(--border)' }}>
              Bonjour ! Comment puis-je vous aider aujourd'hui ?
            </div>
          </div>

          {/* User message */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '.4rem' }}>
            <div style={{ background: 'var(--blue)', color: 'white', padding: '.35rem .5rem', borderRadius: '8px 8px 2px 8px', fontSize: '.52rem', lineHeight: 1.4, maxWidth: '75%' }}>
              Quels sont vos horaires ?
            </div>
          </div>

          {/* Typing indicator */}
          <div style={{ display: 'flex', gap: '.3rem' }}>
            <div style={{ width: '18px', height: '18px', background: 'var(--blue)', color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.55rem', flexShrink: 0 }}>✦</div>
            <div style={{ background: 'var(--white)', padding: '.45rem .55rem', borderRadius: '8px 8px 8px 2px', border: '1px solid var(--border)', display: 'flex', gap: '3px', alignItems: 'center' }}>
              {[0, 1, 2].map((i) => (
                <div key={i} style={{
                  width: '5px', height: '5px', borderRadius: '50%', background: 'var(--ink2)',
                  animation: `typingDot 1.4s ease-in-out infinite`,
                  animationDelay: `${i * 0.2}s`,
                }} />
              ))}
            </div>
          </div>

          {/* Suggestion chips */}
          <div style={{ display: 'flex', gap: '.25rem', marginTop: '.5rem', flexWrap: 'wrap' }}>
            {['Prendre RDV', 'Tarifs', 'Support'].map((s) => (
              <div key={s} style={{ padding: '.2rem .45rem', background: 'var(--white)', border: '1px solid var(--blue)', color: 'var(--blue)', fontSize: '.45rem', fontWeight: 600, borderRadius: '10px' }}>
                {s}
              </div>
            ))}
          </div>
        </div>

        {/* Input */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '.3rem', padding: '.4rem .5rem', borderTop: '1px solid var(--border)' }}>
          <div style={{ flex: 1, fontSize: '.5rem', color: 'var(--ink2)' }}>Écrivez un message…</div>
          <div style={{ width: '18px', height: '18px', background: 'var(--blue)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="8" height="8" viewBox="0 0 10 10" fill="none"><path d="M1 5h7M5 1l4 4-4 4" stroke="white" strokeWidth="1.4" strokeLinecap="round" /></svg>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes typingDot {
          0%, 80%, 100% { transform: scale(.6); opacity: .4; }
          40% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default ChatbotWidget;
